export const FEATURE_KEYS = ['copy_trading', 'smart_portfolios', 'meme', 'master_accounts', 'volume_rewards'];
export const FEATURE_NAMES = {
    copy_trading: 'Copy Trading',
    smart_portfolios: 'Smart Portfolios',
    meme: 'Meme coins',
    master_accounts: 'Master Accounts',
    volume_rewards: 'Volume rewards',
};
export const DEFAULT_FEATURE_SETTINGS = {
    copy_trading: { enabled: false, blockedCountries: [] },
    smart_portfolios: { enabled: false, blockedCountries: [] },
    // Retail crypto derivatives are banned in the UK (FCA PS20/10) and retail CFDs in Belgium (FSMA).
    meme: { enabled: false, blockedCountries: ['GB', 'BE'] },
    master_accounts: { enabled: false, blockedCountries: [] },
    // Earn → Rewards: USDT, trading bonus and rebates for trading volume (VOLUME_REWARDS_PLAN.md).
    volume_rewards: { enabled: false, blockedCountries: [] },
};
export const COPY_STATUSES = ['enabled', 'close_only', 'blocked'];
export const MEME_STATUSES = ['not_assessed', 'enabled', 'blocked'];
const CC_RE = /^[A-Z]{2}$/;
/** Check and normalise settings from the admin form or API. Missing features keep their defaults. */
export function parseFeatureSettings(v, base = DEFAULT_FEATURE_SETTINGS) {
    if (!v || typeof v !== 'object')
        return { ok: false, error: 'Send the feature settings as an object' };
    const out = { ...base };
    for (const [key, raw] of Object.entries(v)) {
        if (!FEATURE_KEYS.includes(key))
            return { ok: false, error: `Unknown feature: ${key}` };
        const k = key;
        if (!raw || typeof raw !== 'object')
            return { ok: false, error: `${FEATURE_NAMES[k]}: send {enabled, blockedCountries}` };
        const r = raw;
        const enabled = r.enabled === undefined ? base[k].enabled : r.enabled;
        if (typeof enabled !== 'boolean')
            return { ok: false, error: `${FEATURE_NAMES[k]}: enabled must be true or false` };
        let countries = base[k].blockedCountries;
        if (r.blockedCountries !== undefined) {
            if (!Array.isArray(r.blockedCountries))
                return { ok: false, error: `${FEATURE_NAMES[k]}: blockedCountries must be a list of country codes` };
            const list = r.blockedCountries.map((c) => (typeof c === 'string' ? c.trim().toUpperCase() : ''));
            const bad = list.find((c) => !CC_RE.test(c));
            if (bad !== undefined)
                return { ok: false, error: `${FEATURE_NAMES[k]}: "${bad}" is not a two-letter country code` };
            countries = [...new Set(list)].sort();
        }
        out[k] = { enabled, blockedCountries: countries };
    }
    return { ok: true, value: out };
}
/** Is the feature offered to a client resident in `residence` connecting from `ipCountry`? */
export function featureOpen(s, residence, ipCountry) {
    if (!s.enabled)
        return false;
    const blocked = (cc) => !!cc && s.blockedCountries.includes(cc.toUpperCase());
    return !blocked(residence) && !blocked(ipCountry);
}
//# sourceMappingURL=features.js.map